import { FC, ChangeEvent, useMemo, ReactNode } from 'react'
import { Category } from 'interfaces/meta'
import styles from 'components/features/external/PublicSpendingFilters/PublicSpendingFilters.styl'
import cn from 'classnames'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { metaSelector } from 'selectors/globalSelectors'
import { getItemsFromCollection } from 'helpers/normalizeHelpers'
import { USStates } from 'constants/geo'
import { PUBLIC_INCOME_RANGES } from 'constants/publicDashboard'
import { CategoryId } from 'interfaces/meta'
import { setPublicFilterActionCreator } from 'actions/publicDashboardActions'
import { USStateCode } from 'interfaces/geo'
import { PublicIncomeRangeId } from 'interfaces/publicDashboard'
import { publicFiltersSelector } from 'selectors/publicDashboardSelectors'
import { ALL_CATEGORY_ID } from 'constants/meta'

type PublicSpendingFiltersProps = {

}

export const PublicSpendingFilters: FC<PublicSpendingFiltersProps> = (props) => {
  const {} = props

  const dispatch = useStoreDispatch()
  const { spending_categories } = useStoreSelector(metaSelector)
  const { category, incomeRange, location } = useStoreSelector(publicFiltersSelector)
  const categoryOptionsChildren = useMemo(() => {
    return getItemsFromCollection<Category, 'id'>(spending_categories).reduce<ReactNode[]>(
      (acc, { id, value }) => {
        if (id === 'transfer') {
          return acc
        }

        acc.push(
          <option key={ id } value={ id }>{ value }</option>
        )

        return acc
      },
      []
    )
  }, [spending_categories])

  const handleCategoryChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const nextCategory = e.target.value as CategoryId | typeof ALL_CATEGORY_ID
    dispatch(setPublicFilterActionCreator({ category: nextCategory }))
  }

  const locationOptionsChildren = useMemo(() => {
    const statesChildren = USStates.map(({ name, code }) => (
      <option key={ code } value={ code }>{ name } ({ code })</option>
    ))
    return (
      <>
        <option key='all' value='all'>All States</option>
        { statesChildren }
      </>
    )
  }, [])

  const handleLocationChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const nextLocation = e.target.value as USStateCode | typeof ALL_CATEGORY_ID
    dispatch(setPublicFilterActionCreator({ location: nextLocation }))
  }

  const incomeRangeOptionsChildren = useMemo(() => {
    const rangesChildren = PUBLIC_INCOME_RANGES.map(({ id, name }) => (
      <option key={ id } value={ id }>{ name }</option>
    ))
    return (
      <>
        <option key='all' value='all'>Any Income</option>
        { rangesChildren }
      </>
    )
  }, [])

  const handleIncomeRangeChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const nextIncomeRange = e.target.value as PublicIncomeRangeId | typeof ALL_CATEGORY_ID
    dispatch(setPublicFilterActionCreator({ incomeRange: nextIncomeRange }))
  }

  return (
    <div className={ styles.publicSpendingFilters }>
      <div className={ cn(styles.filter, styles.category) }>
        <label htmlFor='category' className={ styles.caption }>
          Category
        </label>
        <select
          name='category'
          className={ styles.customSelect }
          value={ category }
          onChange={ handleCategoryChange }
        >
          { categoryOptionsChildren }
        </select>
      </div>
      <div className={ styles.wrapper }>
        <div className={ cn(styles.filter, styles.state) }>
          <label htmlFor='location' className={ styles.caption }>
            Location
          </label>
          <select
            name='location'
            className={ styles.customSelect }
            value={ location }
            onChange={ handleLocationChange }
          >
            { locationOptionsChildren }
          </select>
        </div>
        <div className={ cn(styles.filter, styles.incomeRange) }>
          <label htmlFor='income' className={ styles.caption }>
            Income Range
          </label>
          <select
            name='income'
            className={ styles.customSelect }
            value={ incomeRange }
            onChange={ handleIncomeRangeChange }
          >
            { incomeRangeOptionsChildren }
          </select>
        </div>
      </div>
    </div>
  )
}
